import { render } from "./Blank.vue?vue&type=template&id=5d909b3b&scoped=true"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import "./Blank.vue?vue&type=style&index=0&id=5d909b3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d909b3b"]])

export default __exports__